"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TappableArea = void 0;
var _styledComponents = require("styled-components");
/* TappableArea */
/* The defined/ minimum tappable area for accessibility */
var StyledTappableArea = exports.TappableArea = (0, _styledComponents.css)(["&:after{content:'';display:block;min-height:44px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);min-width:44px;width:100%;}"]);
var _default = exports["default"] = StyledTappableArea;